export const APP_VERSION = import.meta.env.PACKAGE_VERSION || '0.0.0';
